export const STATIC_REFERENCE_DATA_STALE_TIME = 5 * 60 * 1000; // 5 minutes
export const STATIC_REFERENCE_DATA_CACHE_TIME = 30 * 60 * 1000; // 30 minutes

export const CATALOG_DATA_STALE_TIME = 5 * 60 * 1000; // 5 minutes
export const CATALOG_DATA_CACHE_TIME = 4 * 60 * 60 * 1000; // 4 hours
